// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Radio} from 'cap-it-ui.toggles';

const handleProductChange = (context, product) => () => {

    context.onProductHierarchyChange(product.code);

};

const ProductItem = (props, context) =>
    <Radio
        id={`${props.product.code}`}
        name='product-hierarchy'
        onChange={handleProductChange(context, props.product)}
        selected={props.isProductSelected}
    >
        {props.product.description}
    </Radio>;

ProductItem.displayName = 'ProductItem';
ProductItem.propTypes = {
    isProductSelected: PropTypes.bool.isRequired,
    product: PropTypes.shape({
        code: PropTypes.string,
        description: PropTypes.string
    }).isRequired
};
ProductItem.contextTypes = {
    onProductHierarchyChange: PropTypes.func
};

export default ProductItem;



// WEBPACK FOOTER //
// ./src/shared/components/facets/product-hierarchy/product-item.js